import { render, staticRenderFns } from "./PreviousFiles.vue?vue&type=template&id=dadc8b72&scoped=true&"
import script from "./PreviousFiles.vue?vue&type=script&lang=js&"
export * from "./PreviousFiles.vue?vue&type=script&lang=js&"
import style0 from "./PreviousFiles.vue?vue&type=style&index=0&id=dadc8b72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadc8b72",
  null
  
)

export default component.exports